import { useState } from 'react'
import LoginScreen from '../Compnents/Auth'

const Login = () => {
    return (
        <LoginScreen />
    )
}

export default Login